__turbopack_context__.v({
  "article-valve": "ArticleValve-module-scss-module__ThUQsa__article-valve",
});
